import { useEffect } from "react";
import { Navbar } from "./components/Navbar";
import { List } from "./components/List";
import { AlbumForm } from "./components/AlbumForm";
import { AlbumDetails } from "./components/AlbumDetails";
import { photofolioActions, photofolioSelector } from "./redux/reducers/reducers";
import { useSelector, Provider, useDispatch } from "react-redux";

import { db } from "./firebase";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styles.css'

// Import images
import unp1 from './statics/images/unp1.jpg';
import unp2 from './statics/images/unp2.jpg';
import unp3 from './statics/images/unp3.jpg';
import unp4 from './statics/images/unp4.jpg';
import unp5 from './statics/images/unp5.jpg';
import unp6 from './statics/images/unp6.jpg';
import unp7 from './statics/images/unp7.jpg';
import unp8 from './statics/images/unp8.jpg';
import unp9 from './statics/images/unp9.jpg';
import unp10 from './statics/images/unp10.jpg';
import unp11 from './statics/images/unp11.jpg';
import unp13 from './statics/images/unp13.jpg';
import unp15 from './statics/images/unp15.jpg';

function App() {
  const dispatch = useDispatch();
  const {albums} = useSelector(photofolioSelector);
  
  useEffect(() => {
    const fetchAlbums = async () => {
      try {
        const albumsCollection = collection(db, 'albums');
        const unsubscribe = onSnapshot(
          query(albumsCollection, orderBy('createdAt', 'desc')),
          (snapshot) => {
            const albumsData = snapshot.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
              createdAt: new Date().getTime()
            }));
            console.log('Albums have been loaded from Firestore:', albumsData);
            dispatch(photofolioActions.setInitialAlbum(albumsData));
       
          }
        );
      } catch (error) {
        console.error('Error fetching albums:', error);
      }
    };
    fetchAlbums();
  }, []);

  const { albumToggle, toggle } = useSelector(photofolioSelector);

  return (
    <div className="app">
      <ToastContainer />
        <Navbar />

        {albumToggle ? (
          <AlbumDetails />
        ) : (
          <>
            {toggle && <AlbumForm />}
            <List />
          </>
        )}
    </div>
  );
}

export default App;
